export default "__VITE_ASSET__BqkV_qsO__"